
import Vue, { PropType } from 'vue';

export default Vue.extend({
	name: 'MultipleSelect',
	data: () => ({
		available: [],
		selected: [],
		availableChecked: [],
		selectedChecked: [],
		search: null,
		debouncedSearch: null,
		searchTimeout: null,
	}),
	model: {
		prop: 'modelValue',
		event: 'update:modelValue'
	},
	props: {
		modelValue: {
			type: Array as PropType<any[]>,
			required: true
		},
		items: {
			type: Array as PropType<any[]>,
			required: true
		},
		itemKey: {
			type: String,
			required: true
		},
		itemTitle: {
			type: String,
			required: true
		},
		itemSubtitle: {
			type: String,
			required: true
		},
	},
	computed: {
		filteredAvailable() {
			if (this.debouncedSearch) {
				const searchLowerCase = this.debouncedSearch.toLowerCase().trim();

				return this.available.filter(item => {
					return (item[this.itemTitle].toLowerCase().includes(searchLowerCase)
						|| item[this.itemSubtitle].toLowerCase().includes(searchLowerCase));
				});
			} else {
				return this.available;
			};
		},
		filteredSelected() {
			if (this.debouncedSearch) {
				const searchLowerCase = this.debouncedSearch.toLowerCase().trim();

				return this.selected.filter(item => {
					return (item[this.itemTitle].toLowerCase().includes(searchLowerCase)
						|| item[this.itemSubtitle].toLowerCase().includes(searchLowerCase));
				});
			} else {
				return this.selected;
			};
		},
		modelValueKeys() {
			return this.selected.map(item => item[this.itemKey]);
		}
	},
	watch: {
		'search': function (newValue, oldValue) {
			if (this.searchTimeout) {
				clearTimeout(this.searchTimeout);
			};

			this.searchTimeout = setTimeout(() => {
				this.debouncedSearch = newValue;
			}, 600);
		},
		'items': {
			handler(newValue, oldValue) {
				const options = newValue.reduce((acc, currentItem) => {
					if (currentItem.active === 0) {
						acc.available.push(currentItem);
					} else {
						acc.selected.push({
							...currentItem,
							active: 0
						});
					};

					return acc;
				}, {
					available: [],
					selected: []
				});

				this.available = options.available;
				this.selected = options.selected;
			},
			immediate: true
		},
		'modelValueKeys': function (newValue, oldValue) {
			this.$emit('update:modelValue', newValue);
		}
	},
	methods: {
		handleAllCheckedForSelected: function () {
			if (this.availableChecked.length) {
				const checkedKeys = new Set(this.availableChecked);
				this.available = this.available.filter(item => !checkedKeys.has(item[this.itemKey]));

				const availableKeys = new Set(this.available.map(item => item[this.itemKey]));
				this.selected = this.items
					.filter(item => !availableKeys.has(item[this.itemKey]))
					.map(item => ({
						...item,
						active: 0
					}));

				this.availableChecked = [];
			};
		},
		handleAllCheckedForAvailable: function () {
			if (this.selectedChecked.length) {
				const checkedKeys = new Set(this.selectedChecked);
				this.selected = this.selected.filter(item => !checkedKeys.has(item[this.itemKey]));

				const selectedKeys = new Set(this.selected.map(item => item[this.itemKey]));
				this.available = this.items
					.filter(item => !selectedKeys.has(item[this.itemKey]))
					.map(item => ({
						...item,
						active: 0
					}));

				this.selectedChecked = [];
			};
		},
		handleAllForSelected: function () {
			if (this.filteredAvailable.length) {
				const availableKeys = this.filteredAvailable.map(item => item[this.itemKey]);
				const selectedKeys = this.selected.map(item => item[this.itemKey]);
				const allKeys = new Set(availableKeys.concat(selectedKeys));


				this.selected = this.items
					.filter(item => allKeys.has(item[this.itemKey]))
					.map(item => ({
						...item,
						active: 0
					}));

				this.available = this.items
					.filter(item => !allKeys.has(item[this.itemKey]))
					.map(item => ({
						...item,
						active: 0
					}));
			};
		},
		handleAllForAvailable: function () {
			if (this.filteredSelected.length) {
				const selectedKeys = this.filteredSelected.map(item => item[this.itemKey]);
				const availableKeys = this.available.map(item => item[this.itemKey]);
				const allKeys = new Set(selectedKeys.concat(availableKeys));


				this.available = this.items
					.filter(item => allKeys.has(item[this.itemKey]))
					.map(item => ({
						...item,
						active: 0
					}));

				this.selected = this.items
					.filter(item => !allKeys.has(item[this.itemKey]))
					.map(item => ({
						...item,
						active: 0
					}));
			};
		},
		handleClickCheckbox: function (value: 0 | 1, itemKey, typeList: 'available' | 'selected') {
			if (value === 1) {
				if (typeList === 'available') {
					this.availableChecked.push(itemKey);
				} else {
					this.selectedChecked.push(itemKey);
				}
			} else {
				if (typeList === 'available') {
					this.availableChecked = this.availableChecked.filter(key => key !== itemKey);
				} else {
					this.selectedChecked = this.selectedChecked.filter(key => key !== itemKey);
				}
			};
		}
	}
});

